import * as React from "react";
import "./styles.scss";
import { Message } from "../../types/common";

interface CampaignMessageProps {
    message: Message;
}

const CampaignMessage = (props: CampaignMessageProps): JSX.Element => {
    return props.message.description !== "" || props.message.title !== "" ? (
        <div className="campaign-message">
            <div>
                {props.message.title && <h3>{props.message.title}</h3>}
                {props.message.description && (
                    <p>{props.message.description}</p>
                )}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default CampaignMessage;
